const setupSizeChart = () => {
    const DATA_TYPE = Object.freeze({ CLOTHING: 'clothing', SHOES: 'shoes' })
    const deserializeTableJsonData = () => JSON.parse(document.querySelector('.size-chart-data').textContent);
    const activeButtonClassName  = 'size-chart-modal__type-select-button--active'
    const getButtonTrigger = () => document.querySelector('.product-size-chart-popup-trigger');
    const tableShoesClass = 'size-chart-modal__table--shoes'
    let modalContainer, allSelectButtons;

    function toggleBodyScroll(type) {
        document.body.style.overflowY = type === 'enable' ? 'auto' : 'hidden';
    }

    function onClose() {
        modalContainer.remove();
        toggleBodyScroll('enable');
        getButtonTrigger().focus();
        window.removeEventListener("keydown", onEscapeKeyPress);
    }

    function generateClothingTableHeadHTML(clothingHeaders) {
        return `
            <tr>
                <th>${clothingHeaders.col1}</th>
                <th>${clothingHeaders.col2}</th>
                <th>${clothingHeaders.col3}</th>
                <th>${clothingHeaders.col4}</th>
            </tr>
        `
    }

    function generateShoesTableHeadHTML(shoesHeaders) {
        return `
            <tr>
                <th>${shoesHeaders.col1}</th>
                <th>${shoesHeaders.col2}</th>
            </tr>
        `
    }

    function generateTableHead(headers, type = DATA_TYPE.CLOTHING) {
        const thead = document.createElement('thead');
        thead.innerHTML =
            type === DATA_TYPE.CLOTHING ?
            generateClothingTableHeadHTML(headers.clothing) :
            generateShoesTableHeadHTML(headers.shoes)

        return thead;
    }

    function generateTableBodyRows(rows, type) {
        return rows.filter(row => row.type === type).map(row => `
            <tr>
                <td>${row.col1_text}</td>
                <td>${row.col2_text}</td>
                ${type === DATA_TYPE.CLOTHING ? `
                    <td>${row.col3_text}</td>
                    <td>${row.col4_text}</td>
                ` : ''}
            </tr>
        `).join('\n');
    }

    function generateTableBody(type, rows) {
        const tbody = document.createElement('tbody');
        tbody.innerHTML = generateTableBodyRows(rows, type);
        return tbody;
    }

    function updateTableHeaders(table, type, headers) {
        const thead = table.querySelector('thead');
        thead.innerHTML =
            type === DATA_TYPE.CLOTHING ?
                generateClothingTableHeadHTML(headers.clothing) :
                generateShoesTableHeadHTML(headers.shoes);
    }

    function updateTableBody(table, type, rows) {
        const tbody = table.querySelector('tbody');
        tbody.innerHTML = generateTableBodyRows(rows, type);
    }

    function generateTableElement() {
        const { headers, rows } = deserializeTableJsonData();
        console.log({headers});
        const table = document.createElement('table');
        const thead = generateTableHead(headers);
        const tbody = generateTableBody(DATA_TYPE.CLOTHING, rows);

        table.classList.add('size-chart-modal__table');
        table.insertAdjacentElement('afterbegin', thead);
        table.insertAdjacentElement('beforeend', tbody);
        return table;
    }

    function toggleActiveClassOnAllButtons(type) {
        allSelectButtons.forEach(button => {
            type === 'add' ? button.classList.add(activeButtonClassName) : button.classList.remove(activeButtonClassName)
        })
    }

    function toggleTableShoesClass(table, type) {
        if (type === DATA_TYPE.CLOTHING) {
            table.classList.remove(tableShoesClass);
            return
        }

        table.classList.add(tableShoesClass);
    }

    function toggleScrollText(type) {
        const scrollTextIndicator = document.querySelector('.size-chart-modal__scroll-text ');
        const hiddenClass = 'indicator-hidden'

        if (type === DATA_TYPE.CLOTHING) {
            scrollTextIndicator.classList.remove(hiddenClass)
            return
        }

        scrollTextIndicator.classList.add(hiddenClass);
    }

    function onSwitchButtonClick(button, modalContainer) {
        if (button.classList.contains(activeButtonClassName)) return;

        toggleActiveClassOnAllButtons('remove');
        button.classList.add(activeButtonClassName);

        const dataValue = button.getAttribute('data-value');
        const { headers, rows } = deserializeTableJsonData();
        const table = modalContainer.querySelector('.size-chart-modal__table');

        toggleScrollText(dataValue);
        toggleTableShoesClass(table, dataValue);
        updateTableHeaders(table, dataValue, headers);
        updateTableBody(table, dataValue, rows);
    }

    function bindSwitchButtonsClickHandlers(modalContainer) {
        allSelectButtons = modalContainer.querySelectorAll('.size-chart-modal__type-select-button');
        allSelectButtons.forEach(button => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                onSwitchButtonClick(event.target.closest('button.size-chart-modal__type-select-button'), modalContainer);
            });
        })
    }

    function generateModal() {
        const modalContainer = document.createElement('div');
        const { popupHeading, leftSwitchButtonText, rightSwitchButtonText, scrollText } = window.sizeCharts;

        modalContainer.classList.add('size-chart-modal');
        modalContainer.innerHTML = `
        <div class="size-chart-modal__overlay">&nbsp;</div>
        <div class="size-chart-modal__modal" role="dialog">
          <div class="size-chart-modal__close">
            <button type="button">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 256 256"><path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"></path></svg>
            </button>
          </div>

          <h2 class="size-chart-modal__heading">${popupHeading}</h2>
          
          <!--TODO: Make all the labels come from metafields-->
          <div class="size-chart-modal__type-select">
            <button class="size-chart-modal__type-select-button size-chart-modal__type-select-button--active" data-value="clothing">${leftSwitchButtonText}</button>
            <button class="size-chart-modal__type-select-button" data-value="shoes">${rightSwitchButtonText}</button>
          </div>

           <div class="size-chart-modal__table-container">
              ${generateTableElement().outerHTML}
           </div>
           
           <span class="size-chart-modal__scroll-text">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M144,16H112A64.07,64.07,0,0,0,48,80v96a64.07,64.07,0,0,0,64,64h32a64.07,64.07,0,0,0,64-64V80A64.07,64.07,0,0,0,144,16Zm48,160a48.05,48.05,0,0,1-48,48H112a48.05,48.05,0,0,1-48-48V80a48.05,48.05,0,0,1,48-48h32a48.05,48.05,0,0,1,48,48ZM136,83.31v89.38l10.34-10.35a8,8,0,0,1,11.32,11.32l-24,24a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L120,172.69V83.31L109.66,93.66A8,8,0,0,1,98.34,82.34l24-24a8,8,0,0,1,11.32,0l24,24a8,8,0,0,1-11.32,11.32Z"></path></svg> 
               <span>${scrollText}</span>
          </span>
        </div>
    `;

        bindSwitchButtonsClickHandlers(modalContainer);
        return modalContainer;
    }

    function attachOverlayClickHandler() {
        const overlay = modalContainer.querySelector('.size-chart-modal__overlay');
        overlay.addEventListener('click', onClose);
    }

    function attachCloseButtonClickHandler() {
        const closeButton = modalContainer.querySelector('.size-chart-modal__close > button');
        closeButton.addEventListener('click', onClose);
    }

    function focusFirstFocusableElement() {
        modalContainer.querySelector('a,button').focus();
    }

    function onEscapeKeyPress(event) {
        event.key.toLowerCase() === 'escape' && onClose()
    }

    function attachCloseOnEscapeListener() {
        window.addEventListener("keydown", onEscapeKeyPress);
    }

    function renderModal() {
        modalContainer = generateModal();
        toggleBodyScroll('disable');
        document.body.appendChild(modalContainer);
        attachOverlayClickHandler();
        attachCloseButtonClickHandler();
        focusFirstFocusableElement();
        attachCloseOnEscapeListener();
    }

    function attachButtonTriggerEventListener() {
        const buttonTrigger = getButtonTrigger();
        buttonTrigger.addEventListener('click', renderModal);
    }

    document.addEventListener('DOMContentLoaded', attachButtonTriggerEventListener);
};

const setupSizeFittingTooltip = () => {
    const tooltip = document.querySelector('.product-size-chart-fitting-text-icon-wrapper .tooltip');
    const tooltipHiddenClass = 'tooltip-hidden';

    function onOpen() {
        tooltip.classList.remove(tooltipHiddenClass);
        tooltip.ariaHidden = 'false'
    }

    function onClose() {
        tooltip.classList.add(tooltipHiddenClass);
        tooltip.ariaHidden = 'true'
    }


    function attachButtonTriggerClickHandler() {
        const buttonTrigger = document.querySelector('.product-size-chart-fitting-text-icon');
        buttonTrigger.addEventListener('mouseenter', onOpen);
        buttonTrigger.addEventListener('mouseleave', onClose);
        buttonTrigger.addEventListener('focus', onOpen);
        buttonTrigger.addEventListener('blur', onClose);
    }

    document.addEventListener('DOMContentLoaded', attachButtonTriggerClickHandler);
};

setupSizeChart();
setupSizeFittingTooltip();
